import { render, staticRenderFns } from "./PageTypeFilter.vue?vue&type=template&id=33055582&scoped=true&"
import script from "./PageTypeFilter.vue?vue&type=script&lang=js&"
export * from "./PageTypeFilter.vue?vue&type=script&lang=js&"
import style0 from "./PageTypeFilter.vue?vue&type=style&index=0&id=33055582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33055582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
